import { Button, Tabs } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import FiltersForm from '../../components/FiltersForm/FiltersForm';
import Icon from '../../components/Icon/Icon'
import ScheduleEvent from '../../components/ScheduleEvent/ScheduleEvent';


import styles from './Calendar.module.scss';
import RecordingsTab from './RecordingsTab/RecordingsTab';
import ScheduledCallsTab from './ScheduledCallsTab/ScheduledCallsTab';

import { useCalendar } from './useCalendar';

const Calendar = () => {

	const {
		isAuthorized,
    onResetFilters,
		onSubmitFilters,
		onTabChange,
    state,
		toggleMobileFilters,
		toggleScheduleEventPopup
  } = useCalendar();
	const {
		activeTabKey,
		filterDefaultValues,
		filterFields,
		filters,
		recordingsFilterFields,
		showMobileFilters,
		showScheduleEventPopup,
		userId
	} = state;
	const { TabPane } = Tabs;

	const location: any = useLocation();
	const { activeTab } = location.state || {};

	const tabBarExtraContent = {
		right: (
			<div className={styles.tabBarExtraContent}>
			{ isAuthorized(['InitiateCall']) && <Button size="large" type="primary" onClick={toggleScheduleEventPopup}>
          <FormattedMessage id="buttons.scheduleCall"></FormattedMessage>
        </Button>}
			</div>
		)
	};

  return (
		<div className={`${styles.pageContainer} ${styles.contentAsCards}`}>
			<div className={`${styles.pageSider} ${styles.topBorder}`}>
				<FiltersForm
					fields={activeTabKey === '1' ? filterFields : recordingsFilterFields}
					defaultValues={filterDefaultValues}
					onResetFilters={onResetFilters}
					onSubmit={onSubmitFilters}
				/>
			</div>
			<div className={styles.pageContent}>
				<div className={styles.mobileTopper}>
					<Button
						type="text"
						onClick={toggleMobileFilters}
						icon={<Icon color="black" name="sliders-h" />}
					/>
				</div>
				{ isAuthorized(['InitiateCall']) && <div className={styles.tabBarExtraContentMobile}>
					<Button size="large" type="primary" onClick={toggleScheduleEventPopup}>
						<FormattedMessage id="buttons.scheduleCall"></FormattedMessage>
					</Button>
				</div>}
				<Tabs
					className={`navigator ${styles.content}`}
					defaultActiveKey={activeTab?.toString() || '1'}
					tabBarExtraContent={activeTabKey === '1' && tabBarExtraContent}
					destroyInactiveTabPane
					onChange={onTabChange}
				>
					<TabPane
						key="1"
						tab={
							<>
								<FormattedMessage id="navigation.calendar" />
								{isAuthorized(['InitiateCall']) && <span className={styles.tabDivider}>/</span>}
							</>
						}
					>
						<ScheduledCallsTab filters={filters} />
					</TabPane>
					{isAuthorized(['InitiateCall']) &&
						<TabPane
							key="2"
							tab={
								<>
									<Icon
										className={styles.tabIcon}
										name="dot-circle"
										color={activeTabKey === '2' ? 'accent' : 'gray'}
										width="20px"
									/>
									<FormattedMessage id="navigation.recordings" />
								</>
							}
						>
							<RecordingsTab filters={filters} />
						</TabPane>
					}
				</Tabs>
			</div>
			{showScheduleEventPopup && (
				<ScheduleEvent userId={userId} onClose={() => { toggleScheduleEventPopup(); onResetFilters(); }} />
			)}

			{/* Mobile filters */}
			<div
				className={`${styles.mobileFiltersBackdrop} ${
					showMobileFilters ? styles.open : ''
				}`}
			></div>
			<div
				className={`${styles.mobileFilters} ${
					showMobileFilters ? styles.open : ''
				}`}
			>
				<div className={styles.actions}>
					<Button
						onClick={toggleMobileFilters}
						type="link"
						style={{ paddingRight: 0 }}
					>
						<Icon color="text" height="16px" name="times" width="16px" />
					</Button>
				</div>
				<FiltersForm
					fields={activeTabKey === '1' ? filterFields : recordingsFilterFields}
					defaultValues={filterDefaultValues}
					onResetFilters={onResetFilters}
					onSubmit={onSubmitFilters}
				/>
			</div>
		</div>
	);
}
export default Calendar;